/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import 'react-toastify'
import { toast } from "react-toastify";
import Services from "../services/services";
import {setCurrentUser} from "../reducers/authSlice";
import { useEffect, useState } from "react";

const ProtectedRoute = () => {
  const [result, setResult] = useState(null);
  const dispatch = useDispatch()

  const check_authentication = async () => {
    const result = await Services.UserAuth.me();
    const data = await result.json();
    if (result.ok && data.success === true) {
      dispatch(setCurrentUser(data.data));
      setResult(<Outlet />);
    }
    else{
      dispatch(setCurrentUser(null));
      setResult(<Navigate to="/auth" />)
      toast.error("Please login into your account!")
    }
  }

  useEffect(() =>{
    check_authentication();
  }, []);

  return result
};

export default ProtectedRoute;
